import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { useAppZStore } from "src/store/zStore";

interface Props<T = any> {
  tableName: string;
}

/**
 * Used to handle pagination and filter of MUI table.
 * It sets the pagination and filter model within the params of the url (should maybe make this a boolean to choose if url needs to be used)
 *
 * @param initialFormValues Used to check of the form has changed, if not, it should not ask confirmation
 * @returns Pagination and Filter model
 * @returns Pagination and Filter model state update method
 */
export default function useRememberTable<T = any>({ tableName }: Props<T>) {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const filters = useAppZStore((state) => state.filters);

  const filter = useMemo(() => {
    const params: {
      limit: number;
      sortField?: string;
      sortOrder?: string;
    } & T = {
      limit: paginationModel.pageSize,
    } as any;
    if (sortModel.at(0)?.field && sortModel.at(0)?.sort) {
      params["sortField"] = sortModel.at(0)?.field ?? "";
      params["sortOrder"] = sortModel.at(0)?.sort ?? "";
    }
    return {
      ...params,
      ...(filters[tableName] ?? {}),
    };
  }, [filters, paginationModel, sortModel, tableName]);

  return {
    paginationModel,
    setPaginationModel,
    sortModel,
    setSortModel,
    filter,
  };
}
